type DeltaOperation = {
	attributes?: Record<string, unknown>;
};

type QuillDelta = {
	ops?: DeltaOperation[];
};

type QuillEditor = {
	getText: () => string;
	getLength: () => number;
	removeFormat: (start: number, length: number, source: "silent") => void;
};

// Content pasted from a browser must use UGenie's standard body style. Keep
// meaningful editing such as bold, emphasis, lists and links, but discard the
// source site's visual typography and block formatting.
const IMPORTED_VISUAL_FORMATS = [
	"size",
	"font",
	"header",
	"color",
	"background",
	"align",
	"indent",
] as const;

export const normalisePastedDelta = <T extends QuillDelta>(delta: T): T => {
	delta.ops?.forEach((operation) => {
		if (!operation.attributes) return;
		IMPORTED_VISUAL_FORMATS.forEach((format) => {
			delete operation.attributes?.[format];
		});

		if (Object.keys(operation.attributes).length === 0) {
			delete operation.attributes;
		}
	});

	return delta;
};

// Quill retains a line's formats after its text is removed. Resetting an empty
// document prevents the next keystroke from silently inheriting a pasted H1,
// colour or font size.
export const resetEmptyEditorFormatting = (editor: QuillEditor): boolean => {
	if (editor.getText().trim().length > 0) return false;

	editor.removeFormat(0, editor.getLength(), "silent");
	return true;
};
